import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import useTimer from "../../hooks/useTimer";
import { timeDifference } from "../../utils/time-difference/time-difference";
import { postData } from "../Api/CommonApi";
import { createUser, otpResend } from "../Api/Links";
import FormComponent from "../React/Formik/FormComponent";
import FormikComponent from "../React/Formik/FormikComponent";
import SlideComponent from "../React/Toast/SlideComponent";

const validationSchema = yup.object({
	otpVerify: yup.string().required("Otp value is required"),
});

const OtpVerification = (props) => {
	const { state } = useLocation();
	const navigate = useNavigate();
	const [difference, setDifference] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [message, setMessage] = useState({
        messageType: "",
        message: "",
    });

	useEffect(() => {
		if (state === null) {
			navigate("/");
		} else if (state?.endDate && state?.id) {
			getTimeDifference(state.endDate);
		}
	}, []);

	const getTimeDifference = (time) => {
		let diff = timeDifference(time);
		setDifference(diff);
	};

	const timer = useTimer(difference);

	const handleResend = () => {
		let headerContentType = "application/json";
		let body = {
			id: state.id,
		};
		postData(
			otpResend,
			body,
			headerContentType,
			(res) => {
				setShowAlert(true);
				setMessage({
					...message,
					messageType: "success",
					message: "Operation Successful",
				});
				getTimeDifference(res.data.data.endDate);
			},
			(err) => {
				console.log(JSON.stringify(err, null, 2));
			}
		);
	};

	const handleSubmit = (values) => {
		console.log(values, "values");
		let currentTime = new Date().getTime();
		let headerContentType = "application/json";
		let body = {
			id: state.id,
			otpToken: values?.otpVerify,
			currentTime: currentTime.toString(),
		};
		setIsLoading(true);
		setDifference(0);
		postData(
			createUser,
			body,
			headerContentType,
			(res) => {
				console.log(res, "res");
				setIsLoading(false);
				navigate({
						pathname: "/login",
						state: { data: res.data.message },
					});
			},
			(err) => {
				console.log(JSON.stringify(err, null, 2));
			}
		);
	};

	return (
		<section className="membership_app_wrapper mt-5">
			<div className="container">
				<h2 className="my-5">OTP Verification</h2>
				<div>
					<FormikComponent
						initialValues={{ otpVerify: "" }}
						validationSchema={validationSchema}
						onSubmit={handleSubmit}
					>
						<FormComponent
							type="text"
							label="OTP"
							name="otpVerify"
						/>
						<div className="d-flex justifiy-content-end">
							<button
								className="btn btn-pri"
								type="submit"
								disabled={isLoading}
							>
								{isLoading && (
									<i class="fa fa-circle-o-notch fa-spin text-white mr-2"></i>
								)}
								Submit
							</button>
						</div>
					</FormikComponent>
					<small className="text-secondary">
						The code will expire in &nbsp;
						<span className="text-gray-16 font-semibold">
							{timer.timer || "0:0"}
						</span>
					</small>
					<div className="mt-5">
						<small className="text-secondary">
							Didn’t get the code?
							<span
								onClick={handleResend}
								className="text-primary"
								role="button"
							>
								Resend OTP
							</span>
						</small>
					</div>
				</div>
			</div>
			{showAlert && (
                <SlideComponent
                    transition="left"
                    show={showAlert}
                    handleClose={() => {
                        setShowAlert(false);
                    }}
                    messageType={message.messageType}
                    message={message.message}
                />
            )}
		</section>
	);
};

export default OtpVerification;
